// Íconos FontAwesome del panel Admin::.
// Importado desde controllers/admin/index.js.
//
// Módulo autocontenido: importa y registra (library.add) los íconos regular
// que usan las vistas del admin. Vive separado de application.js para mantener
// el namespace admin desacoplado del resto del producto. Como es un módulo ES
// propio, no choca con los imports de application.js aunque algún ícono se
// repita (library.add es idempotente).

import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faBuilding as faBuildingRegular,
  faReceipt as faReceiptRegular,
  faGauge as faGaugeRegular,
  faBars as faBarsRegular,
  faXmark as faXmarkRegular,
  faArrowRightFromBracket as faArrowRightFromBracketRegular,
  faCircleUser as faCircleUserRegular,
  faMagnifyingGlass as faMagnifyingGlassRegular,
  faMoon as faMoonRegular,
  faSun as faSunRegular,
  faPen as faPenRegular,
  faCreditCard as faCreditCardRegular,
  faTable as faTableRegular,
  faCircleXmark as faCircleXmarkRegular,
  faTriangleExclamation as faTriangleExclamationRegular,
  faRotateRight as faRotateRightRegular,
  faDownload as faDownloadRegular,
  faSpinnerThird as faSpinnerThirdRegular,
  faBell as faBellRegular,
  faGear as faGearRegular,
} from "@fortawesome/pro-regular-svg-icons";

library.add(
  faBuildingRegular,
  faReceiptRegular,
  faGaugeRegular,
  faBarsRegular,
  faXmarkRegular,
  faArrowRightFromBracketRegular,
  faCircleUserRegular,
  faMagnifyingGlassRegular,
  faMoonRegular,
  faSunRegular,
  faPenRegular,
  faCreditCardRegular,
  faTableRegular,
  faCircleXmarkRegular,
  faTriangleExclamationRegular,
  faRotateRightRegular,
  faDownloadRegular,
  faSpinnerThirdRegular,
  faBellRegular,
  faGearRegular,
);
